import { render, staticRenderFns } from "./semi_skilled_wolker.vue?vue&type=template&id=52414310&"
import script from "./semi_skilled_wolker.vue?vue&type=script&lang=js&"
export * from "./semi_skilled_wolker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports